/*
 * @Author: gaobin
 * @Date: 2025-06-07 17:26:45
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2025-08-04 14:23:39
 * @Description: main.js
 */

import GoEasy from 'goeasy';
import { createSSRApp } from 'vue';
import Vuex from 'vuex';
import App from './App.vue';

// 引入css
import './common/styles/index.scss';

// 路由拦截器
import './utils/addInterceptor.js';

// 数据存储引入
import store from './store';

// 国际化
import { i18n, i18ntReplaceVal, languages, localLanguage } from './locale';

// 接口请求
import FUNS from './services';

// 引入埋点
import { eventTracker } from './utils/eventTracker.js';
import { customRP } from './utils/routerLoadTracker.js';
import { sendTracker } from './utils/tracking.js';

// 引入全局加载动画方法
import { useLoading } from '@/composables/useGlobalLoading';

import AsyncErrorCom from '@/components/async-error/index.vue';
import asyncLoadingCom from '@/components/async-loading/index.vue';
import httpFunc from '@/services/uni-request.js';

const { getBaseURL } = httpFunc;

const goEasy = GoEasy.getInstance({
  host: 'singapore.goeasy.io',
  // 根据环境配置不同的appkey
  appkey:
    getBaseURL() === 'https://www.sharerclub.com'
      ? 'BC-494241fe711b4887bab68560cf9ecc00' // 生产环境
      : 'BC-41d7c493647c4b36b60a3e3996f9009c', // 开发环境

  modules: ['im', 'pubsub'],
  allowNotification: true, // true表示支持通知栏提醒，false则表示不需要通知栏提醒
  // host: 'hangzhou.goeasy.io',
  // appkey: 'BC-88f7697f631f44b5a885ba8e099b4bd8',
  // modules: ['im', 'pubsub'],
  // allowNotification: true, // true表示支持通知栏提醒，false则表示不需要通知栏提醒
});

// #ifdef H5
// 检测路由加载速度
customRP.initListeners();
// #endif

export function createApp() {
  const app = createSSRApp(App);
  app.use(store);
  app.use(i18n);

  app.component('AsyncError', AsyncErrorCom);
  app.component('AsyncLoading', asyncLoadingCom);

  // 配置全局方法
  app.config.globalProperties.$services = FUNS;
  app.config.globalProperties.$store = store;
  app.config.globalProperties.$goEasy = goEasy;
  app.config.globalProperties.$useLoading = useLoading;
  app.config.globalProperties.$project = 'shareClub';
  app.config.globalProperties.$tr = i18ntReplaceVal;
  app.config.globalProperties.$sendTracker = sendTracker;
  app.config.globalProperties.$eventTracker = eventTracker;

  // 重设框架语言环境
  i18n.global.setLocaleMessage(localLanguage, languages[localLanguage]);
  // store.commit('SET_LANGUAGE', localLanguage);
  return {
    app,
    Vuex,
  };
}
